// extracted by mini-css-extract-plugin
module.exports = {"title":"TheBattery_title_38iNV","batteryWrap":"TheBattery_batteryWrap_3JSYj","batteryText":"TheBattery_batteryText_3A-eY","battery":"TheBattery_battery_3npCO"};